import Command from './Command';

export default class CommandHelper
{

	static createFormInstance( 
		className, 
		methodName, 
		returnType="FormDataSourceGroupResult")
	{
		return Command.create("layerForm", className, null, null, methodName, returnType);
	}
	
	static createReportInstance( 
		className, 
		methodName, 
		returnType)
	{
		return Command.create("layerReport", className, null, null, methodName, returnType);
	}
		
	static createJobInstance( 
		className, 
		methodName, 
		returnType)
	{
		return Command.create("job", className, null, null, methodName, returnType);
	}
		

}


// WEBPACK FOOTER //
// ./src/remote/CommandHelper.js